import { Controller } from "@hotwired/stimulus"

// Décompte en direct avant la destruction automatique d'une review app (cf. ExpiryComponent) :
// le serveur n'envoie que l'échéance, le reste se calcule ici, à l'heure du navigateur. Le
// texte rendu par le serveur reste en place si l'échéance est illisible.
export default class extends Controller {
  static targets = ["time"]
  static values = { deadline: String, expired: String }

  connect() {
    this.deadline = Date.parse(this.deadlineValue)
    if (Number.isNaN(this.deadline)) return

    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
    this.timer = null
  }

  tick() {
    const remaining = this.deadline - Date.now()
    if (remaining <= 0) {
      this.timeTarget.textContent = this.expiredValue
      clearInterval(this.timer)
      return
    }

    // Arrondi vers le haut : « 0:00:00 » n'apparaît jamais avant l'échéance.
    const total = Math.ceil(remaining / 1000)
    const hours = Math.floor(total / 3600)
    const minutes = String(Math.floor((total % 3600) / 60)).padStart(2, "0")
    const seconds = String(total % 60).padStart(2, "0")
    this.timeTarget.textContent = `${hours}:${minutes}:${seconds}`
  }
}
